import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  CopyIcon,
  DeleteIcon,
  EmptyStarIcon,
  IconPencil,
  StarIcon,
} from '@/shared/components/Icons';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import { CanCreate, CanDelete, CanUpdate } from '@/shared/components/security';
import messages from './priceGridMessages';

const PriceGridSideBar = ({
  grids,
  activeGrid,
  onChangeGrid,
  onDeleteGrid,
  onCopyGrid,
  onEditGrid,
  intl,
}) => (
  <div>
    <ul className="nav nav-settings nav-stacked">
      {grids.map(grid => (
        <li
          key={grid.id}
          className={classnames({ active: grid.id === activeGrid })}
          onClick={() => onChangeGrid(grid)}
        >
          <a className="text-right">
            <span className="pull-left">{grid.name}</span>
            <span style={{ display: 'inline-block' }}>
              <CanUpdate on="pricelist">
                <IconPencil
                  className="fa-fw margin5R"
                  tooltip={intl.formatMessage(messages.ChangePriceGridName)}
                  onClick={e => {
                    e.stopPropagation();
                    onEditGrid(grid);
                  }}
                />
              </CanUpdate>
              <CanCreate on="pricelist">
                <CopyIcon
                  className="fa-fw margin5R"
                  onClick={e => {
                    e.stopPropagation();
                    onCopyGrid(grid);
                  }}
                />
              </CanCreate>
              <CanDelete on="pricelist">
                <DeleteIcon
                  className="fa-fw"
                  onClick={e => {
                    e.stopPropagation();
                    onDeleteGrid(grid);
                  }}
                />
              </CanDelete>
            </span>
          </a>
        </li>
      ))}
    </ul>
  </div>
);

PriceGridSideBar.propTypes = {
  grids: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  activeGrid: PropTypes.string,
  onChangeGrid: PropTypes.func.isRequired,
  onDeleteGrid: PropTypes.func.isRequired,
  onCopyGrid: PropTypes.func.isRequired,
  onEditGrid: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

PriceGridSideBar.defaultProps = {
  activeGrid: null,
};

export default injectIntl(PriceGridSideBar);
